import { compose } from 'redux';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import localStorage from 'store';
import { sendQuoteRequest as _sendQuoteRequest } from 'js/store/actions/auth';
import ModalRequestQuote from 'js/components/organisms/Modals/ModalRequestQuote/ModalRequestQuote';

var mapStateToProps = function mapStateToProps(state) {
  return {
    userAccount: localStorage.get('userAccount'),
    product: state.user.productForQuoteRequest
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sendQuoteRequest: function sendQuoteRequest(userInfo) {
      return dispatch(_sendQuoteRequest(userInfo));
    }
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), connectModal({
  name: 'RequestQuoteModal',
  destroyOnHide: false
}))(ModalRequestQuote);